import { AppNS } from 'app';
import { FileInfo } from 'app/ui/components/multi-file-uploader/MultiFileUploader';
import axios from 'axios';

import { API_URL } from '../../core/config';
import { parseDocumentResponse } from '../agency-documents/agency-documents-parsers';

const DOCUMENTS_URL = 'documents';

export function apiAddDocument(reqData: AppNS.Params): Promise<FileInfo> {
  return new Promise((resolve, reject) => {
    axios
      .post(`${API_URL}/${DOCUMENTS_URL}.json?return_properties=true`, reqData)
      .then(({ data }) => {
        if (data.model) {
          // Added timeout because of s3 404 error when private url is invoked immediately
          setTimeout(() => {
            resolve(parseDocumentResponse(data.model));
          }, 500);
        } else {
          reject('Invalid response data');
        }
      })
      .catch(reject);
  });
}

export function apiDeleteDocument(id: string): Promise<FileInfo> {
  return new Promise((resolve, reject) => {
    axios
      .delete(`${API_URL}/${DOCUMENTS_URL}.json`, { params: { id } })
      .then(({ data }) => {
        if (data.model) {
          resolve(data.model.id);
        } else {
          reject('Invalid response data');
        }
      })
      .catch(reject);
  });
}
